import {
  Breadcrumbs as MDBreadcrumbs,
  BreadcrumbsProps as MDBreadcrumbsProps,
} from '@mui/material';

export const Breadcrumbs = MDBreadcrumbs;

export type BreadcrumbsProps = MDBreadcrumbsProps;
